import { useEffect, useState } from 'react';

import { findLink } from '@src/main/modules/common/link/application/find/findLink';
import { Link } from '@src/main/modules/common/link/domain/Link';
import { LinkRepository } from '@src/main/modules/common/link/domain/LinkRepository';

export const useLinkUseCases = (linkRepository: LinkRepository) => {
  const [link, setLink] = useState<Link | undefined>(undefined);

  const updateLink = async (linkUpdate: Link) => {
    await linkRepository.updateLink(linkUpdate);
    setLink(linkUpdate);
  };

  useEffect(() => {
    loadLinkInfo(linkRepository, setLink);
  }, [linkRepository, setLink]);

  return { link, updateLink };
};

const loadLinkInfo = async (linkRepository: LinkRepository, setLink: (link: Link) => void) => {
  const link: Link = await findLink(linkRepository);
  setLink(link);
};
